import { Button, ButtonSizes, Text } from "@clockout-dev/design-elements";
import styles from './styles/successAuth.module.scss';
import SuccessIcon from './elements/SuccessIcon';

export default function SuccessAuth({title, titlePartTwo, description, continueButtonText, continueButtonOnClick}) {
    return (
        <div className={styles.successContainer}>
            <div className={styles.card}>
                <div className={styles.contentSection}>
                    <SuccessIcon />
                    <div className={styles.headingSection}>
                        <Text size="display-xl" as="h2" className={styles.title}>
                            {title}<br />
                            {titlePartTwo ? <Text size="display-xl" as="span" className={styles.titleHighlight}>{titlePartTwo}</Text> : null }
                        </Text>
                        <div className={styles.divider} />
                        <Text as="p" size="xl" className={styles.description}>
                            {description}
                        </Text>
                    </div>
                    <Button
                        type="button"
                        size={ButtonSizes.MEDIUM}
                        block
                        onClick={() => continueButtonOnClick()}
                    >
                        {continueButtonText}
                    </Button>
                </div>
            </div>
        </div>
    );
}
